import { render, staticRenderFns } from "./TASideButton.vue?vue&type=template&id=2b0c5a3f&scoped=true&"
import script from "./TASideButton.vue?vue&type=script&lang=ts&"
export * from "./TASideButton.vue?vue&type=script&lang=ts&"
import style0 from "./TASideButton.vue?vue&type=style&index=0&id=2b0c5a3f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b0c5a3f",
  null
  
)

export default component.exports